import { JwtTokenFullData } from 'multirpc-sdk';

import { decryptJWT } from './decryptJWT';

const decodedJWTsCache: Record<string, JwtTokenFullData> = {};

export interface DecodeJWTParams {
  isEncrypted: boolean;
  token: string;
}

export const decodeJWT = async ({ isEncrypted, token }: DecodeJWTParams) => {
  if (decodedJWTsCache[token]) {
    return decodedJWTsCache[token];
  }

  const decodedJWT = await decryptJWT(token, isEncrypted);

  decodedJWTsCache[token] = decodedJWT;

  return decodedJWT;
};
